import FinancialSummary from './FinancialSummary';

export default FinancialSummary;
